export const MenuType = Object.freeze({
    MEAT: 'Meat',
    VEGETARIAN: 'Vegetarian',
    SEAFOOD: 'Seafood',
    DESSERT: 'Dessert',
    BEVERAGES: 'Beverages',
    FOODPACKAGE: 'Food Package'
})

export const UserType = Object.freeze({
    ADMIN: "admin",
    CUSTOMER: "customer",
    STAFF: "staff"
})